import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'booleanReadable'
})
export class BooleanReadablePipe implements PipeTransform {
  transform(value: boolean) {
    if (value === true) {
      return 'Ja';
    }
    if (value === false) {
      return 'Nein';
    }
    return '';
  }
}
